/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Bluefin from './Bluefin/index'
import No from './No/index'
import Payabli from './Payabli/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/AddAction/Content/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let addProviderProviderValueData = fromData.useDataValue({ viewPath,
context: 'add_provider',
path: 'provider',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: addProviderProviderValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Bluefin'}>
<Bluefin
  viewPath={`${viewPath}/Bluefin`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Payabli'}>
<Payabli
  viewPath={`${viewPath}/Payabli`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}